import React from "react";
import Modal from "react-bootstrap/Modal";
import "./popalerterror.css";
import PopupError from "../../assets/images/errorData.svg";
import Button from "../ThemeButton/ThemeButton";
import PropTypes from "prop-types";

const PopupAlertError = ({
  show,
  setShow,
  alertMessage,
  popImage,
  handleCancel,
  handleSubmit,
  cancelText,
  // handleOut,
  buttonText,
  className,
  status,
  errorAlertOnly,
}) => {
  return (
    <div>
      <Modal show={show} className={`alertBoxModal popupAlert ${className}`}>
        <div className="contentContainerConfirmAlert">
          <Modal.Header closeButton>
            <div className="imgTitles">
              <img src={PopupError} alt="icon" />
            </div>
            <Modal.Title>Error</Modal.Title>
            <div className="modalBody">{alertMessage}</div>
          </Modal.Header>
          {errorAlertOnly && (
            <Modal.Footer>
              <div className="btnSuccessAlert">
                <Button value="Close" onClick={handleCancel}></Button>
              </div>
            </Modal.Footer>
          )}
          {!errorAlertOnly && (
            <Modal.Footer>
              <div className="buttonOk">
                <div className="cancelBtns">
                  <Button
                    value={cancelText ? cancelText : "Cancel"}
                    onClick={handleCancel}
                  ></Button>
                </div>
                <Button
                  value={buttonText}
                  onClick={() => {
                    // if (status === 401) {
                    //   removeCookie("authorization");
                    // }
                    handleSubmit();
                  }}
                ></Button>
              </div>
            </Modal.Footer>
          )}
        </div>
      </Modal>
    </div>
  );
};

PopupAlertError.proptype = {
  setShow: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
  alertMessage: PropTypes.string,
  buttonSubmitText: PropTypes.string,
};
export default PopupAlertError;
